import { apiService } from "../../services";
import { serviceHelper } from "../../services/helper";
import {
  emailConstants,
  filterConstants,
  issuesConstants,
  modelConstants,
  projConstants,
} from "../constants";
import { labelType } from "../../components/enums/labelType";

export const projActions = {
  getProjects,
  openProject,
  returnProjects,
  getResourceToken,
  clearResourceToken,
};

// The resource token is stable for a day but a plugin session can outlive it, so it is refetched
// shortly before it expires - a url composed with an expired token is rejected when the browser
// finally loads the image.
const TOKEN_REFRESH_BUFFER_MS = 60 * 1000;
const MIN_TOKEN_REFRESH_DELAY_MS = 60 * 1000;

let resourceTokenTimer;
let resourceTokenRequestId = 0;

function getProjects(ids) {
  return (dispatch) => {
    apiService
      .getProjects(ids)
      .then((projects) => {
        dispatch(registerProjects(projects));
      })
      .catch((error) => {
        console.log("Can't get a project. ", error.message);
      });
  };

  function registerProjects(projects) {
    return {
      type: projConstants.PROJ_GETAll,
      payload: projects,
    };
  }
}

function openProject(project) {
  return (dispatch) => {
    apiService
      .getArrayOData(`label?$filter=type in ('${labelType.Tags}')`, [])
      .then((data) => {
        project.tags = data;
      })
      .catch((err) => {
        console.log("Can't get the tags in project.", err.message);
      });

    apiService
      .getArrayOData(`label?$filter=type in ('${labelType.WorkPhase}')`, [])
      .then((data) => {
        project.workPhases = data;
      })
      .catch((err) => {
        console.log("Can't get the WorkPhases in project.", err.message);
      });

    apiService
      .getData("collaborator-permissions")
      .then((res) => {
        project.actions = res.data.actions;
      })
      .catch((err) => {
        console.log("Can't get Collaborator Permissions", err.message);
      });

    apiService
      .getData("collaboratorgroup")
      .then((res) => {
        project.collaboratorGroups = res.data;
      })
      .catch((err) => {
        console.log("Can't get user groups", err.message);
      });

    apiService
      .getData("collaborator")
      .then((res) => {
        project.userPreviews = res.data;
      })
      .catch((err) => {
        console.log("Can't get Collaborators", err.message);
      });
    apiService
      .getDataByEndpoint(`inbox-email`)
      .then((res) => {
        dispatch(registerEmails(res.data));
      })
      .catch((err) => {
        console.log("Can't get the emails in project", err.message);
      });

    dispatch(getResourceToken());
    dispatch(registerProject(project));
  };

  function registerProject(project) {
    return {
      type: projConstants.PROJ_OPEN,
      payload: project,
    };
  }

  function registerEmails(emails) {
    return {
      type: emailConstants.GET_EMAIL,
      payload: emails,
    };
  }
}

function getResourceToken() {
  return (dispatch) => {
    // A response of a project the user has already left must neither install a token nor a new
    // timer, so every cleanup invalidates the requests that are still in flight.
    const requestId = ++resourceTokenRequestId;
    apiService
      .getDataByEndpoint("resource-token")
      .then((res) => {
        if (requestId !== resourceTokenRequestId) return;

        dispatch(registerResourceToken(res.data));
        scheduleRefresh(
          dispatch,
          Date.parse(res.data?.expiresAt) - TOKEN_REFRESH_BUFFER_MS - Date.now()
        );
      })
      .catch((err) => {
        console.log("Can't get the resource token of the project.", err.message);
        if (requestId !== resourceTokenRequestId) return;

        // Without a token no thumbnail of the project loads at all, so a failed request is retried
        // instead of leaving the project without images until the user reopens it.
        scheduleRefresh(dispatch, MIN_TOKEN_REFRESH_DELAY_MS);
      });
  };

  function registerResourceToken(resourceToken) {
    return {
      type: projConstants.PROJ_SET_RESOURCE_TOKEN,
      payload: resourceToken,
    };
  }

  function scheduleRefresh(dispatch, delay) {
    clearResourceToken();
    if (isNaN(delay)) return;

    resourceTokenTimer = setTimeout(
      () => dispatch(getResourceToken()),
      Math.max(delay, MIN_TOKEN_REFRESH_DELAY_MS)
    );
  }
}

function clearResourceToken() {
  clearTimeout(resourceTokenTimer);
  resourceTokenTimer = undefined;
  resourceTokenRequestId += 1;
}

function returnProjects(history) {
  return (dispatch) => {
    serviceHelper.clearCurrentProjectId();
    localStorage.removeItem("projectToken");
    clearResourceToken();
    dispatch(resetFilter());
    dispatch(resetIssues());
    dispatch(resetModels());
    history.push("/Projects");
    dispatch({ type: projConstants.PROJ_RETURN });
  };

  function resetIssues() {
    return {
      type: issuesConstants.ISSUES_CLEAR,
    };
  }

  function resetFilter() {
    return {
      type: filterConstants.FILTER_RESET,
    };
  }

  function resetModels() {
    return {
      type: modelConstants.MODEL_CLEAR,
    };
  }
}
